import React, { useCallback, useContext, useRef, useState } from 'react';
import moment from 'moment';

// axios
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';

// utils
import { moneyFilter, payStatusFilter, payTypeFilter } from '../../utils/textFilter';

// filter
import { SyrupPaymentsFilter } from '../../components/SyrupComponents/SyrupPaymentsFilter';

// regacy-components
import UserInfoModalContext from '../../data_system/contexts/user_context/user_info_modal_context';

// components
import CreatedPayInfoModal from '../../components/Common/Payments/CreatedPayInfoModal';
import PayInfoDetailModal from '../../components/SyrupComponents/PayInfoDetailModal';
import UserModal from '../../components/UserComponents/UserModal';
import MainTable from '../../designComponents/tables/MainTable';
import SearchbarWithDropdown from '../../designComponents/searchbars/SearchbarWithDropdown';
import { TopSideButton } from '../../designComponents/buttons/TopSideButton';
import FlexMainWrapper from '../../designComponents/wrappers/FlexMainWrapper';
import { DefaultModal } from '../../designComponents/modals/ModalComponent';
import UserLists from './UserLists';
import AddSyrup from './AddSyrup';
import TableFilter from '../../designComponents/filters/TableFilter';
import { createHeartGrantIdempotencyKey } from '../../utils/heartGrantIdempotency';

/* 시럽 결제 */
const SyrupPayments = () => {
    const { user_info_modal_state } = useContext(UserInfoModalContext);

    const [createPaymentsModal, setCreatePaymentsModal] = useState(false);
    const [payInfoDetailToggle, setPayInfoDetailToggle] = useState([false, 0]);
    const [userParam, setUserParam] = useState({});
    const [addSyrup, setAddSyrup] = useState({});
    const [pending, setPending] = useState(false);
    const pendingRef = useRef(false);
    const attemptRef = useRef(null);

    const [searchType, setSearchType] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [params, setParams] = useState({
        orderByType: 1,
        orderType: 1,
    });

    const ref = useRef(null);

    const saveSyrup = async () => {
        if (pendingRef.current) return;
        const body = {
            user_id: Number(userParam.userData.id),
            sinor_love: Number(addSyrup.sinor_love),
            reason_type: addSyrup.reason_type,
            reason_detail: (addSyrup.reason_detail || '').trim(),
        };
        if (!Number.isInteger(body.sinor_love) || body.sinor_love < 1 || body.sinor_love > 1000000) return alert('하트 개수를 1~1,000,000 사이의 정수로 입력해 주세요.');
        if (!body.reason_detail || Array.from(body.reason_detail).length > 40) return alert('지급 사유를 1~40자로 입력해 주세요.');
        const action = body.reason_type === 1 ? '차감' : '지급';
        if (!window.confirm(`하트 ${action}을 진행하시겠습니까?`)) return;

        pendingRef.current = true;
        setPending(true);
        try {
            const fingerprint = JSON.stringify(body);
            if (attemptRef.current?.fingerprint !== fingerprint) {
                const key = createHeartGrantIdempotencyKey(body.user_id);
                attemptRef.current = { fingerprint, key };
            }
            const response = await RefreshCheckApi.post('/adminSyrup', body, { headers: { 'Idempotency-Key': attemptRef.current.key } });
            const result = response.data?.result;
            if (response.status !== 200 || response.data?.ok !== true || !Number.isSafeInteger(result?.pay_id) || result.pay_id <= 0 || !Number.isSafeInteger(result?.balance) || result.balance < 0) {
                throw new Error(response.data?.message || '처리 결과를 확인할 수 없습니다. 같은 내용으로 다시 시도해 주세요.');
            }
            ref?.current?.refresh();
            alert(`하트 ${action}이 완료되었습니다.`);
            setAddSyrup({});
        } catch (error) {
            alert(error.response?.data?.message || error.message || `하트 ${action}에 실패했습니다. 다시 시도해 주세요.`);
        } finally {
            pendingRef.current = false;
            setPending(false);
        }
    };

    const callApi = async (page, param) => {
        let input = {
            page: page,
            size: 10,
            searchType: searchType,
            searchWord: searchText,
            ...params,
        };
        const response = await RefreshCheckApi.post('/adminSyrup/payments/list', input);
        return response.data.data;
    };

    const pageCountCallApi = async (page, param) => {
        let input = {
            page: page,
            size: 10,
            searchType: searchType,
            searchWord: searchText,
            ...params,
        };
        const response = await RefreshCheckApi.post('/adminSyrup/payments/list', input);
        return response.data.all_cnt;
    };

    return (
        <div>
            {createPaymentsModal && (
                <CreatedPayInfoModal
                    setToggle={setCreatePaymentsModal}
                    refresh={() => {
                        ref?.current?.refresh();
                    }}
                />
            )}
            {user_info_modal_state.modalVisible && <UserModal />}
            {payInfoDetailToggle[0] && <PayInfoDetailModal payInfoDetailToggle={payInfoDetailToggle} setToggle={setPayInfoDetailToggle} />}
            {userParam.toggle && (
                <DefaultModal
                    title={'시럽 등록 > 회원 선택'}
                    bodyWidth={79}
                    bottomBtnOn
                    closeOn={true}
                    xIcon={true}
                    boxStyle={{ width: '135vh', height: '90vh' }}
                    onClickClose={() => setUserParam({})}
                    onClickBottomClose={() => setUserParam({})}
                >
                    <UserLists
                        onClickUser={(item) => {
                            if (pendingRef.current) return;
                            setUserParam({ toggle: false, userData: item });
                            setAddSyrup({ toggle: true, reason_type: 0 });
                            attemptRef.current = null;
                        }}
                    />
                </DefaultModal>
            )}
            {addSyrup.toggle && (
                <DefaultModal
                    title={`시럽 등록 (${userParam.userData.name}/${userParam.userData.nickname})`}
                    bodyWidth={29}
                    bottomBtnOn
                    saveOn={true}
                    saveText={addSyrup.reason_type === 1 ? '차감' : '지급'}
                    cancelText={'이전'}
                    closeOn={true}
                    xIcon={true}
                    boxStyle={{ width: '95vh', height: '40vh' }}
                    onClickClose={() => {
                        if (!pendingRef.current) setAddSyrup({});
                    }}
                    onClickBottomClose={() => {
                        if (pendingRef.current) return;
                        setUserParam({ toggle: true });
                        setAddSyrup({ toggle: false });
                    }}
                    onClickSave={saveSyrup}
                >
                    <AddSyrup
                        data={userParam.userData}
                        body={addSyrup}
                        pending={pending}
                        setBody={(body) => {
                            if (!pendingRef.current) setAddSyrup(body);
                        }}
                    />
                </DefaultModal>
            )}

            <FlexMainWrapper style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <SearchbarWithDropdown
                    list={[
                        { id: 1, title: '휴대폰번호', value: 1 },
                        { id: 2, title: '이름', value: 2 },
                        { id: 3, title: '닉네임', value: 3 },
                    ]}
                    resetThenSet={useCallback((item) => {
                        setSearchType(item.value);
                    }, [])}
                    onChangeSubmit={(e) => {
                        e.preventDefault();
                        ref?.current?.refresh();
                    }}
                    searchText={searchText}
                    onChangeInput={(e) => {
                        const value = e.target.value;
                        setSearchText(searchType === 1 ? value.replaceAll('-', '') : value);
                    }}
                />

                <TopSideButton
                    rightOn={false}
                    text01={'결제 내역 생성'}
                    onClick={() => setCreatePaymentsModal((prev) => !prev)}
                    leftWidth={100}
                    text03={'하트 등록'}
                    middleWidth={70}
                    onClickMiddle={() => {
                        if (!pendingRef.current) setUserParam({ toggle: true });
                    }}
                />
            </FlexMainWrapper>

            <TableFilter
                param={params}
                setParam={setParams}
                topFilterLists={[
                    {
                        filterText: '정렬 기준',
                        orderLists: [{ name: '사용 일시', type: 1 }],
                        onChange: (e, type) => {
                            let obj = { ...params };
                            if (e.target.checked)
                                obj.orderByType = type; // setOrderbyType(type);
                            else delete obj.orderByType;
                            setParams(obj);
                        },
                        orderbyType: params.orderByType,
                    },
                    {
                        filterText: '정렬 방식',
                        orderLists: [
                            { name: '내림 차순', type: 1 },
                            { name: '오름 차순', type: 2 },
                        ],
                        onChange: (e, type) => {
                            let obj = { ...params };
                            if (e.target.checked)
                                obj.orderType = type; // setOrderbyType(type);
                            else delete obj.orderType;
                            setParams(obj);
                        },
                        orderbyType: params.orderType,
                    },
                ]}
                filterLists={[
                    {
                        key: 'pay_status',
                        value: '결제 상태',
                        filter: [
                            {
                                key: 0,
                                value: '결제 대기 중',
                            },
                            {
                                key: 1,
                                value: '입금 대기 중',
                            },
                            {
                                key: 2,
                                value: '결제 완료',
                            },
                            {
                                key: 3,
                                value: '환불 신청',
                            },
                            {
                                key: 4,
                                value: '환불 완료',
                            },
                            {
                                key: 5,
                                value: '환불 거절',
                            },
                            {
                                key: 6,
                                value: '기간 만료',
                            },
                            {
                                key: 7,
                                value: '환불 정보 입력 요청',
                            },
                            {
                                key: 8,
                                value: '결제 취소',
                            },
                            {
                                key: 9,
                                value: '승인 처리 중',
                            },
                        ],
                    },
                    {
                        key: 'pay_type',
                        value: '결제 방식',
                        filter: [
                            {
                                key: -1,
                                value: '0원 결제 ',
                            },
                            {
                                key: 1,
                                value: '무통장 입금',
                            },
                            {
                                key: 0,
                                value: '카드 결제',
                            },
                            {
                                key: 4,
                                value: '계좌 이체',
                            },
                            {
                                key: 6,
                                value: 'App Store',
                            },
                            {
                                key: 7,
                                value: 'Play Store',
                            },
                            {
                                key: 8,
                                value: '해외 카드',
                            },
                        ],
                    },
                ]}
                research={ref}
            />

            <MainTable
                ref={ref}
                tableStyle={{}}
                toggleBlur={true}
                loadingText={'시럽결제 데이터를 불러오고 있습니다.'}
                headerData={SyrupPaymentsFilter}
                checkID={'id'}
                param={params}
                setParam={setParams}
                callApi={callApi}
                pageCountCallApi={pageCountCallApi}
                onClickRowItem={(item) => () => {
                    setPayInfoDetailToggle([true, item.id]);
                }}
                tbodyRenderItem={(key, value) => {
                    if (key === 'accumulate_amount' || key === 'amount') return <span>{moneyFilter(value)}원</span>;
                    if (key === 'created_at') return moment(value).format('YYYY-MM-DD HH:mm:ss');
                    if (key === 'user_name') return <span style={{ fontWeight: 600 }}>{value}</span>;
                    if (key === 'point') return <span>{moneyFilter(value)}P</span>;
                    if (key === 'pay_status') return <span>{payStatusFilter(Number(value))}</span>;
                    if (key === 'pay_type') return <span>{payTypeFilter(Number(value))}</span>;

                    return value;
                }}
            />
        </div>
    );
};

export default SyrupPayments;
